import forEach from 'lodash-es/forEach';
import set from 'lodash-es/set';
import filter from 'lodash-es/filter';
import map from 'lodash-es/map';
import reduce from 'lodash-es/reduce';

const ClassName = {
  BLOCK: 'custom-file',
  INPUT: 'custom-file__input',
  REMOVE: 'files-panel__remove',
};

const Selectors = {
  LIST: '[data-target="files"]',
};

class CustomFile {
  constructor(block) {
    this.block = block;
    this.input = this.block.getElementsByClassName(ClassName.INPUT).item(0);
    this.files = [];
    this.filesList = document.querySelector(Selectors.LIST);
    this.filesStr = '';

    this.init = this.init.bind(this);
    this.changeHandle = this.changeHandle.bind(this);
    this.createElement = this.createElement.bind(this);
    this.addElementToList = this.addElementToList.bind(this);
    this.deleteHandle = this.deleteHandle.bind(this);
    this.actualizeInputFiles = this.actualizeInputFiles.bind(this);

    this.init();
  }

  init() {
    if (this.filesList) this.input.addEventListener('change', this.changeHandle);
  }

  changeHandle(evt) {
    if (!evt.target.files.length) {
      return;
    }

    // Проверяем добавлены ли новые файлы
    const filteredFiles = Array.from(evt.target.files).filter((file) => {
      return !this.filesStr.includes(file.name);
    });

    // Рендерим новые файлы
    filteredFiles.forEach((file) => {
        this.createElement(file);
    });

    // Храним состояние добавленных файлов, добавляем которых еще не было
    this.files = [...this.files, ...filteredFiles];

    // Создаем подсказу для фильтрации при добавлении новых файлов
    this.filesStr = reduce(this.files, (result, file) => {
      return result + file.name;
    }, '');

    this.actualizeInputFiles();
  }

  createElement(file) {
    const elem = `
    <div class="files-panel__col">
      <a download href="#" class="files-panel__item">
        ${file.name}
        <div class="files-panel__remove" data-name="${file.name}">
          <i class="fi fi_icon_close-o"></i>
        </div>
      </a>
    </div>
    `;
    this.addElementToList(elem);
  }

  addElementToList(elem) {
    this.filesList.insertAdjacentHTML('afterbegin', elem);
    const removeBtn = this.filesList.getElementsByClassName(ClassName.REMOVE).item(0);
    removeBtn.addEventListener('click', this.deleteHandle);
  }

  // Актуализируем состояние input.files в соответсвии с this.files
  actualizeInputFiles() {
    const dt = new DataTransfer();
    this.files.forEach((file) => {
      dt.items.add(file);
    });

    this.input.files = dt.files;
  }

  deleteHandle(evt) {
    evt.preventDefault();
    const {name} = evt.target.dataset;
    this.files = this.files.filter((file) => file.name !== name);

    const block = this.filesList.querySelector(`[data-name="${name}"]`).closest('.files-panel__col');
    block.remove();

    // Удаляем из строки со всеми файлами название удаленноо файла
    this.filesStr = this.filesStr.replace(name, '');
    this.actualizeInputFiles();
  }

  static getAllBlocks() {
    return Array.from(document.getElementsByClassName(ClassName.BLOCK));
  }

  static getAllInstances() {
    return map(filter(CustomFile.getAllBlocks(), ({ins}) => ins), (item) => item.ins);
  }

  static initAllBlocks() {
    let Blocks = CustomFile.getAllBlocks();
    forEach(Blocks, (block) => {
      if (block.ins) return;
      block.ins = new CustomFile(block);
    });
  }
}

// Инициашизация;
CustomFile.initAllBlocks();

// Экспорт;
set(window, ['Block', 'CustomFile'], CustomFile);
export default CustomFile;
